import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from 'components/Button'
import { useDispatch } from 'react-redux'
import { editReceptionFields } from 'redux/modules/receptions/actions'

const Repeated = ({ classes, onClose, reception }) => {
  const dispatch = useDispatch()

  const setRepeated = (mark) => {
    dispatch(
      editReceptionFields(
        { repeatedCall: mark, receptionId: reception.id },
        (data) => {
          onClose(true)
        },
        (error) => {
          console.log('error', error)
        }
      )
    )
  }

  return (
    <div className={classes.root}>
      <Button
        otherStyles={{ margin: '0 1em 1em 0' }}
        fullWidth
        active
        text="+ (Был обзвон)"
        onClick={() => setRepeated(true)}
      />
      <Button
        otherStyles={{ margin: '0 0 1em 1em' }}
        fullWidth
        text="- (Не было обзвона)"
        onClick={() => setRepeated(false)}
      />
    </div>
  )
}

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '300px'
  }
})

export default withStyles(styles)(Repeated)
